import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/routers/constant'

const router: Array<RouteRecordRaw> = [
  {
    path: '/verification',
    component: Layout,
    redirect: '/verification/index',
    meta: {
      title: '核销管理',
      keepAlive: true,
      requiresAuth: true,
      auth: ['inspection_verification']
    },
    children: [
      {
        path: 'index',
        name: 'VerificationIndex',
        component: () => import('@/views/app/verification/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '核销管理'
        }
      }
    ]
  }
]

export default router
